import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import BgImg from "../../../images/location_new/uk-web/build_uk_web.webp";
import Modal from "react-bootstrap/Modal";
import PopUp from "../../components/popUp";

function Businessgrowthuk() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <section
        className="business_growth_uk p-100 text_white"
        style={{
          backgroundImage: `url(${BgImg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Container>
          <Row>
            <Col xs={12} md={8} lg={7} xl={5} xxl={5} className="">
              <h2>Build a Website That Drives Results</h2>
              <p>
                Discover our custom web solutions designed to optimise
                performance and increase conversions.
              </p>
              <div className="app_growth_main">
                <div className="app_growth_item">
                  <button
                    style={{ background: "#F47a14", color: "#fff" }}
                    onClick={handleShow}
                    className="border_btn"
                    aria-label="TekRevol Contact"
                  >
                    Start Your Project
                  </button>
                </div>
                <div className="app_growth_item">
                  <h5>OR</h5>
                </div>
                <div className="app_growth_item">
                  <div className="app_all">
                    <div className="app_growth_img">
                      <StaticImage
                        src="../../../images/location_new/uk-mobile/get_phone_icon.webp"
                        alt="TekRevol"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={57}
                        height={57}
                      />
                    </div>
                    <div className="app_growth_num">
                      <Link to="tel:+441223926620">+441-223-926620</Link>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-popup"
      >
        <div className="modal_forms">
          <PopUp setShow={setShow} />
        </div>
      </Modal>
    </>
  );
}

export default Businessgrowthuk;
